module.exports = __webpack_public_path__ + "img/leftList1_active.5fc5ac95.svg";